import { Button, Divider, Popover, Select, Space } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Cookies from 'js-cookie';
import { apiCall } from "../utils/Api";
import { useSession } from "../utils/Session";
import AccountCard from "./AccountCard";
import LogOutLocations from "./LogOutLocations";
import SelectStores from "./SelectStores";
import { usePrefs } from "../utils/Prefs";
import Newsletters from "./Newsletters";

export default function AccountBox() {

    const history = useHistory();
    const [session, setSession] = useSession();
    const [trigger, setTrigger] = useState(false);
    const [storeChanged, setStoreChanged] = useState(false);
    const [prefs, setPrefs] = usePrefs();
    const [open, setOpen] = useState(false)

    const drawCorps = () => {
        return session.available_corps.filter(item => item.name !== "My Personal Account").map(item => {
            return (<Select.Option key={item.id} value={item.id} label={item.name}>{item.name}</Select.Option>)
        })
    }

    const switchStore = (_id) => {


        // Account redirection for stores, b2b
        let _full = session.available_corps.find(item => item.id == _id);
        if (_full && _full?.url) {
            window.open(_full.url, "blank");
            return;
        }


        let bmBrief = Cookies.get("bm_brief") ? JSON.parse(Cookies.get("bm_brief")) : null;

        if (bmBrief) {
            bmBrief.pub_oh_oo = false;
            Cookies.set("bm_brief", JSON.stringify(bmBrief));
        }

        history.push("/reload", { id: _id, path: history.location.pathname });
    }

    const logout = () => {
        apiCall("account/logout", {}, (_status, _result) => {
            window.store_id = false;
            setSession(_result);
            history.push("/")
        })
    }

    const content = (
        <Space direction="vertical">
            <label>Account</label>


            <Select
                className='ant-select-with-custom-arrow'
                onChange={(e) => switchStore(e)}
                getPopupContainer={trigger => trigger.parentElement}
                showSearch
                filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                }
                defaultValue={session.corp_id}
                style={{ width: 250 }}>
                {drawCorps()}
            </Select>
            <Divider dashed style={{ "margin": "5px 0px" }} />
            <Newsletters />

            {/* Must not have salesisbn subscription to see store data */}
            {((!session?.subscriptions.salesisbn && session?.permissions.accounts && !session?.subscriptions.catalogue) &&
                <SelectStores onChange={(e) => {
                    if (e) {
                        setPrefs({ ...prefs, "selected": "ind-store-data" });
                        Cookies.set("selected", "ind-store-data");
                    }
                    setStoreChanged(true);
                }} />
            )}

            <LogOutLocations trigger={trigger} />
            <Button onClick={() => { setOpen(false); history.push("/account/edit") }} block>Edit my Account</Button>
            <Button onClick={() => logout()} danger type="primary" block>Log out</Button>
        </Space>
    );

    const refreshPage = () => {
        if (storeChanged) {

            window.location.reload();
        }
    }

    return (
        <>
            <Popover onVisibleChange={(e) => {
                if (e) {
                    setOpen(true)
                    setTrigger(!trigger);
                } else {
                    setOpen(false);
                    refreshPage();
                }
            }}
                visible={open}
                placement="bottomRight"
                content={content}
                trigger="click">
                <div style={{ "cursor": "pointer" }}>
                    <Space size={0} direction="vertical">
                        <div><AccountCard store_name={session.picklist_identity} contact={session.contact} /></div>

                    </Space>
                </div>
            </Popover>
        </>
    );
}